import InputAdornment from "@mui/material/InputAdornment";
import TextField from '@mui/material/TextField';

export const InputText = ({label, id, requested, unit, value, setValue}) => {

    const handelChanges = (inputValue) => {
        setValue(inputValue);
    }

    return (
        <div className={"flex flex-col justify-center max-h-[400px] max-w-[500px] w-full"}>
            <h4 className="font-semibold text-sm mb-0 lg:mb-1 text-gray-900">
                {label}<span className='ml-1 text-sm font-light text-indigo-900 text-xs'>{requested ? '(Pflichtfeld)' : ''}</span>
            </h4>
            <label htmlFor={id} className="sr-only">
                {label}
            </label>
            <TextField
                fullWidth
                className="text-gray-900 mt-1 px-4 text-sm w-full border border-gray-500 bg-transparent rounded-sm placeholder:text-gray-600"
                name={id}
                required={requested}
                value={value}
                size="small"
                onChange={(e) => {handelChanges(e.target.value)}}
                placeholder={'...'}
                InputProps={{
                    endAdornment: <InputAdornment position="end">{unit}</InputAdornment>
                }}
            />
        </div>
    )
}
